import React from 'react'

const Header = ({}) => (
    <thead>
        <tr className="audience-list audience-list--header">
            <th className="audience-list audience-list--audience">Partner ID</th>
            <th className="audience-list audience-list--audience">Friendly Name</th>
            <th className="audience-list audience-list--audience">Region</th>
            <th className="audience-list audience-list--audience" style={{ width: '15%' }}>
                Partner Type
            </th>
            <th className="audience-list audience-list--audience" style={{ width: '15%' }}>
                Cookie Type
            </th>
            
            <th className="audience-list audience-list--edit">Actions</th>
        </tr>
    </thead>
)

export default Header
